var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_20687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7742 5.82038L5.54696 13.2868L14.9691 18.1903L18.7892 8.90301L10.7742 5.82038ZM10.1203 3.69238L21.0974 7.91513L15.8658 20.6324L2.9624 13.9159L10.1203 3.69238Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08 16.5596C5.78104 16.5596 7.16 15.1884 7.16 13.4971C7.16 11.8057 5.78104 10.4346 4.08 10.4346C2.37896 10.4346 1 11.8057 1 13.4971C1 15.1884 2.37896 16.5596 4.08 16.5596Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.24 7.80957C11.9411 7.80957 13.32 6.43844 13.32 4.74707C13.32 3.0557 11.9411 1.68457 10.24 1.68457C8.539 1.68457 7.16003 3.0557 7.16003 4.74707C7.16003 6.43844 8.539 7.80957 10.24 7.80957Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.92 11.3096C21.621 11.3096 23 9.93844 23 8.24707C23 6.5557 21.621 5.18457 19.92 5.18457C18.2189 5.18457 16.84 6.5557 16.84 8.24707C16.84 9.93844 18.2189 11.3096 19.92 11.3096Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5199 22.6846C17.221 22.6846 18.5999 21.3134 18.5999 19.6221C18.5999 17.9307 17.221 16.5596 15.5199 16.5596C13.8189 16.5596 12.4399 17.9307 12.4399 19.6221C12.4399 21.3134 13.8189 22.6846 15.5199 22.6846Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_20687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white",
    transform: "translate(1 1.68457)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawPolygon);
export default __webpack_public_path__ + "static/media/DrawPolygon.14fa6c4162d80b4cde196b50cff6eafc.svg";
export { ForwardRef as ReactComponent };